import React, { useState, useEffect, useCallback, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { TablePagination } from 'react-md';
import "./style.css";

const customStyles = {
    headCells: {
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
        },
    },
};


const SFCustomTable = (props) => {

    const [data, setData] = useState([]);
    const [slicedData, setSlicedData] = useState([]);
    const [selectedData, setSelectedData] = useState([]);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
            setSlicedData(props.data.slice(0, 20));
        }

    }, [props.data]);

    useEffect(() => {
        console.debug("props.selectedData",props.selectedData)
        if (props.selectedData) {
            setSelectedData([...props.selectedData]);
        }
    }, [props.selectedData])


    return (
        <div style={{position:"relative"}}>
            <div className='sf-custom-table-top-pagination'>
                <TablePagination
                    rowsPerPageItems={[10, 20, 50, 100]}
                    defaultRowsPerPage={20}
                    rows={data?.length}
                    rowsPerPageLabel=""
                    onPagination={props.onPagination}
                />
            </div>
            <DataTable
                columns={props.columns}
                data={slicedData}
                selectableRows={props.selectableRows}
                onSelectedRowsChange={props.onSelectedRowsChange}
                customStyles={customStyles}
                selectableRowSelected={(row) => {
                    if (selectedData.includes(row.userid)) {
                        return row;
                    }
                }}
            />
            <div className='sf-custom-table-bottom-pagination'>
                <TablePagination
                    rowsPerPageItems={[10, 20, 50, 100]}
                    defaultRowsPerPage={20}
                    rows={data?.length}
                    rowsPerPageLabel=""
                    onPagination={props.onPagination}
                />
            </div>
        </div>
    );
}

export default SFCustomTable;
